"use strict";
ui.loadTemplateFile("characterselect.html");

class CharacterSelectDialog extends Dialog {
    _element: any;
    _titleBar: any;
    _characterList: any;
    _characters: any;
    _canManageGm: boolean;

    constructor(characters: any, canManageGm: boolean) {
        super("characterselect.html");

        this._characterList = ui.list(this, ".list.characters");
        this._characterList.on("itemclicked", this._changeCharacter.bind(this));
        this._characterList.on(
            "itemdoubleclicked",
            this._selectCharacter.bind(this)
        );

        ui.button(this, ".button.select").on(
            "clicked",
            this._selectCharacter.bind(this)
        );
        ui.button(this, ".button.create").on(
            "clicked",
            this._onCreateClicked.bind(this)
        );
        ui.button(this, ".button.delete").on(
            "clicked",
            this._onDeleteClicked.bind(this)
        );
        ui.button(this, ".button.back").on(
            "clicked",
            this._onBackClicked.bind(this)
        );

        this._canManageGm = !!canManageGm;
        ui.button(this, ".button.gm").on("clicked", this._onGmClicked.bind(this));
        this._element.find(".gm").toggle(this._canManageGm);
        this._characters = characters;
        this._update();
    }

    _update() {
        const prevIndex = Math.max(this._characterList.index(), 0);
        this._characterList.clear();

        for (let i = 0; i < this._characters.length; ++i) {
            let character = this._characters[i];
            const item = ui.listitem();
            let html = "";
            html += "<b>" + character.name + "</b><br />";
            html += "Level: " + character.level + "<br />";

            if (character.deleteTime) {
                const hours = Math.floor(character.deleteTime / 60 / 60);
                const minutes = Math.floor(character.deleteTime / 60) - hours * 60;
                html +=
                    "<span style='color:red;'>Deleting in " +
                    hours +
                    "h " +
                    minutes +
                    "m</span>";
            } else {
                html += "Location: " + character.zoneName;
            }

            item.html(html);
            this._characterList.append(item);
        }

        this._characterList.index(prevIndex);
        this._updateGmButton();
    }

    _updateGmButton() {
        if (!this._canManageGm) return;
        const index = this._characterList.index();
        const character = this._characters[index];
        if (!character) return;
        ui.button(this, ".button.gm").text(
            character.isGm ? "Revoke GM" : "Promote to GM"
        );
    }

    _onGmClicked() {
        this.emit("togglegm");
    }

    _changeCharacter(index: any) {
        index = index || this._characterList.index();
        if (index == -1) return;
        const character = this._characters[index];
        const text =
            character.deleteTime > 0 ? "Undelete Character" : "Delete Character";
        ui.button(this, ".button.delete").text(text);
        this._updateGmButton();
        this.emit("selectionChanged", index);
    }

    _selectCharacter(index: any) {
        index = index || this._characterList.index();
        this.emit("done", this._characters[index].name);
        this.close();
    }

    _onCreateClicked() {
        if (this._characterList.length < 5) this.emit("create");
        else ui.statusDialog("There are already 5 characters");
    }

    _onDeleteClicked() {
        this.emit("delete");
    }

    _onBackClicked() {
        this.emit("cancel");
    }
}

ui.CharacterSelectDialog = CharacterSelectDialog;
ui.characterSelectDialog = function (characters: any, canManageGm: boolean) {
    return new ui.CharacterSelectDialog(characters, canManageGm);
};
